export type PortfolioFilter = "toate" | "active" | "arhivate" | "cu-alerte";
export type PortfolioSort = "ultima-activitate" | "nume-az";
export type PortfolioView = "grid" | "list";

export type PortfolioPrefs = {
  filter: PortfolioFilter;
  sort: PortfolioSort;
  view: PortfolioView;
};

export const PORTFOLIO_PREFS_KEY = "companies_portfolio_prefs";

export const DEFAULT_PORTFOLIO_PREFS: PortfolioPrefs = {
  filter: "toate",
  sort: "ultima-activitate",
  view: "grid",
};

const VALID_FILTERS: PortfolioFilter[] = [
  "toate",
  "active",
  "arhivate",
  "cu-alerte",
];
const VALID_SORTS: PortfolioSort[] = ["ultima-activitate", "nume-az"];
const VALID_VIEWS: PortfolioView[] = ["grid", "list"];

function isValid<T extends string>(
  allowed: readonly T[],
  value: unknown
): value is T {
  return (
    typeof value === "string" && (allowed as readonly string[]).includes(value)
  );
}

export function loadPortfolioPrefs(): PortfolioPrefs {
  if (typeof window === "undefined") return DEFAULT_PORTFOLIO_PREFS;
  try {
    const raw = window.localStorage.getItem(PORTFOLIO_PREFS_KEY);
    if (!raw) return DEFAULT_PORTFOLIO_PREFS;
    const parsed = JSON.parse(raw) as Partial<PortfolioPrefs>;
    return {
      filter: isValid(VALID_FILTERS, parsed.filter)
        ? parsed.filter
        : DEFAULT_PORTFOLIO_PREFS.filter,
      sort: isValid(VALID_SORTS, parsed.sort)
        ? parsed.sort
        : DEFAULT_PORTFOLIO_PREFS.sort,
      view: isValid(VALID_VIEWS, parsed.view)
        ? parsed.view
        : DEFAULT_PORTFOLIO_PREFS.view,
    };
  } catch {
    return DEFAULT_PORTFOLIO_PREFS;
  }
}

export function savePortfolioPrefs(prefs: PortfolioPrefs): void {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(PORTFOLIO_PREFS_KEY, JSON.stringify(prefs));
  } catch {
    // ignore quota / privacy errors
  }
}
